var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeLapse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7456 20C14.9546 20 12.5907 19.0312 10.6536 17.0938C8.71663 15.1562 7.74812 12.7917 7.74812 10C7.74812 7.22917 8.71663 4.86979 10.6536 2.92188C12.5907 0.973958 14.9546 0 17.7456 0C20.5158 0 22.8745 0.973958 24.822 2.92188C26.7694 4.86979 27.7431 7.22917 27.7431 10C27.7431 12.7917 26.7694 15.1562 24.822 17.0938C22.8745 19.0312 20.5158 20 17.7456 20ZM17.7456 17.5C19.8284 17.5 21.5988 16.7708 23.0568 15.3125C24.5148 13.8542 25.2437 12.0833 25.2437 10C25.2437 7.91667 24.5148 6.14583 23.0568 4.6875C21.5988 3.22917 19.8284 2.5 17.7456 2.5C15.6628 2.5 13.8924 3.22917 12.4344 4.6875C10.9765 6.14583 10.2475 7.91667 10.2475 10C10.2475 12.0833 10.9765 13.8542 12.4344 15.3125C13.8924 16.7708 15.6628 17.5 17.7456 17.5ZM20.5887 14.6562L22.3695 12.875L18.9953 9.5V5H16.4959V10.5312L20.5887 14.6562ZM1.49969 6.25V3.75H6.49843V6.25H1.49969ZM0.25 11.25V8.75H6.49843V11.25H0.25ZM1.49969 16.25V13.75H6.49843V16.25H1.49969Z",
    fill: "#515253"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeLapse);
export default __webpack_public_path__ + "static/media/time_Lapse.7ccc6eea758e211f8e60d1d8fb6ddf27.svg";
export { ForwardRef as ReactComponent };